import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./i18n";
import * as Sentry from "@sentry/react";
import { API_URLS } from "./config/api";

// Only send PII (IP, cookies, headers) if the user has explicitly accepted error monitoring
// and their consent has not expired (12-month GDPR limit).
const CONSENT_EXPIRY_MS = 365 * 24 * 60 * 60 * 1000;
let errorMonitoringConsented = false;
try {
  const raw = localStorage.getItem("cookie_consent");
  if (raw) {
    const parsed = JSON.parse(raw);
    const notExpired = Date.now() - (parsed?.consentedAt ?? 0) < CONSENT_EXPIRY_MS;
    errorMonitoringConsented = parsed?.errorMonitoring === true && notExpired;
  }
} catch {
  // ignore — defaults to false (safe)
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "",
  enabled: import.meta.env.PROD,
  integrations: [
    Sentry.browserTracingIntegration({
      // Only create spans for our own backend — skip Google Maps, HERE, OpenAI, S3, etc.
      shouldCreateSpanForRequest: (url) =>
        Object.values(API_URLS).some((base) => base && url.includes(base)),
    }),
  ],
  // 10% sampling in production is the standard recommendation
  tracesSampleRate: 0.1,
  // Only propagate trace headers to our own APIs
  tracePropagationTargets: Object.values(API_URLS)
    .filter(Boolean)
    .map((base) => new RegExp(`^${base}/`)),
  // Only capture errors from our own code, not third-party scripts (Google Maps, HERE, etc.)
  allowUrls: [/https:\/\/((www|app)\.)?mdf\.lu\//],
  sendDefaultPii: errorMonitoringConsented,
});

// Tell TypeScript: "root" will NOT be null
const rootElement = document.getElementById("root") as HTMLElement;

ReactDOM.createRoot(rootElement).render(<App />);
